export default {
    success: "Uspjeh!",
    error: "Greška!",
    errorMessage: "Došlo je do greške, molimo Vas pokušajte kasnije.",
};
